import { FC } from 'react';
import classNames from 'classnames';
import capitalize from 'lodash-es/capitalize';

import { useFallbackTranslation } from '@gn-audio/jss-components';

import { UnitType } from './videoRoiCalculatorTypes';

interface VideoRoiCalculatorUnitSwitcherProps {
  activeUnit: UnitType;
  onUnitChange: (unit: UnitType) => void;
  className?: string;
}

export const VideoRoiCalculatorUnitSwitcher: FC<VideoRoiCalculatorUnitSwitcherProps> = ({
  activeUnit,
  onUnitChange,
  className,
}) => {
  const { t } = useFallbackTranslation();

  const unitButtonClasses =
    'rounded-t-full px-4 py-2 pb-4 text-sm font-semibold transition-[opacity,transform] duration-300 ease-in-out';
  const activeClasses = 'translate-y-0 bg-primary text-on-brand opacity-100';
  const inactiveClasses = 'translate-y-2 bg-green-700 text-white opacity-80 hover:opacity-100';

  return (
    <div className={classNames('flex items-end justify-end', className)}>
      {(['ft', 'm'] as UnitType[]).map((unit) => (
        <button
          key={unit}
          className={classNames(unitButtonClasses, {
            [activeClasses]: activeUnit === unit,
            [inactiveClasses]: activeUnit !== unit,
          })}
          onClick={() => onUnitChange(unit)}
          aria-pressed={activeUnit === unit}
        >
          {t(`system.P50Roi${capitalize(unit)}`)}
        </button>
      ))}
    </div>
  );
};
